// Cola de lecturas del kiosko sin conexión (respaldo en el navegador).
// Si se cae el Wi-Fi, cada escaneo se guarda aquí con su hora real y se
// sincroniza en orden (más antiguo primero) cuando vuelve la conexión.
const KEY = "uaic_kiosk_queue";

export function getQueue() {
  try {
    const v = localStorage.getItem(KEY);
    const arr = v ? JSON.parse(v) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function setQueue(arr) {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch { /* almacenamiento lleno o bloqueado: ignorar */ }
}

// Encola una lectura. Devuelve el item creado.
export function enqueueScan(code) {
  const item = { id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, code, at: new Date().toISOString() };
  const arr = getQueue();
  arr.push(item);
  setQueue(arr);
  return item;
}

export function removeFromQueue(id) {
  setQueue(getQueue().filter((i) => i.id !== id));
}

export function queueCount() {
  return getQueue().length;
}
